import React, { useEffect, useState } from 'react'
import moment from 'moment'
import { questionActions } from '../../store/actions'
import { connect } from 'react-redux'
import history from '../../route/history'
import * as Common from '../../assets/js/common.js'

const QuestionDetail = (props) => {
  const queryString = require('query-string')
  const [fileList, setFileList] = useState(new Array(2))
  const [state, setState] = useState({
    ansYn: null,
  })
  const [params, setParams] = useState({
    seq: '',
    token: '',
  })

  useEffect(() => {
    setParams({
      seq: props.seq,
      token: '',
    })
  }, [props])

  useEffect(() => {
    setFileList(props.fileList)
  }, [props.fileList])

  useEffect(() => {
    props.detail(props.seq, props.searchInfo)
  }, [props.seq])

  useEffect(() => {
    if (props.select?.openYn === 'N' && !props.searchInfo?.isConfirm) {
      return goList(true)
    }

    props.select?.ansYn && setState({ ...state, ansYn: props.select.ansYn })
  }, [props.select])

  const goPrev = (seq, openYn = 'Y') => {
    if (openYn === 'N') {
      props.showPwdPopup(true, 'DETAIL', seq)
    } else {
      history.push({ pathname: '/question/' + seq, state: props.searchInfo })
    }
  }

  const goNext = (seq, openYn = 'Y') => {
    if (openYn === 'N') {
      props.showPwdPopup(true, 'DETAIL', seq)
    } else {
      history.push({ pathname: '/question/' + seq, state: props.searchInfo })
    }
  }

  const goList = (isReplace = false) => {
    props.searchInfo?.isConfirm && delete props.searchInfo.isConfirm
    let paramStr = queryString.stringify(props.searchInfo)
    paramStr.length > 0 && (paramStr = '?' + paramStr)

    if (isReplace) {
      history.replace('/question' + paramStr)
    } else {
      history.push('/question' + paramStr)
    }
  }

  const fileDownload = (url, originFileNm) => {
    // 정책 변경 시 추가 작업 해야함...
    console.log('url', url)
    console.log('originFileNm', originFileNm)
    window.M.pop.alert('IOS 정책이 변경되어 WEB에서만 다운로드가 가능합니다.')

    // var outputFilePath = '/storage/emulated/0/Download/test/' + originFileNm
    // window.M.execute(
    //   'exWNFileDownload',
    //   url,
    //   outputFilePath,
    //   window.M.response
    //     .on(function (status, result) {
    //       console.log('status', status)
    //       console.log('result', JSON.stringify(result))
    //       window.M.pop.alert('IOS 정책이 변경되어 WEB에서만 다운로드가 가능합니다.')
    //     })
    //     .toString(),
    // )
  }

  return (
    <React.Fragment>
      <ul className="view-board">
        <li className="view-title">
          <h3>
            {props.select?.questTitle}
            {props.select?.encPasswd?.length > 0 ? <i className="lock">잠김</i> : null}
            {props.fileList?.length > 0 ? <i className="file">첨부파일</i> : null}
          </h3>
        </li>
        <li className="view-info">
          <div className="left">
            <span className="tit">카테고리</span>
            <em>{props.select?.questCdName}</em>
          </div>
          <div className="right">
            <span className="tit">작성자</span>
            <em>{props.select?.regName}</em>
          </div>
        </li>
        <li className="view-info">
          <div className="left">
            <span className="tit">등록일자</span>
            <em>{moment(props.select?.regDt).format('YYYY.MM.DD')}</em>
          </div>
          <div className="right">
            <span className="tit">조회수</span>
            <em>{props.select?.viewCount}</em>
          </div>
        </li>
        <li className="view-attach">
          <div className="tit">첨부파일</div>
          <ul className="attach-list">
            {fileList?.map((item, idx) => {
              return (
                <React.Fragment key={idx}>
                  {Common.getDeviceType() === 'MobileApp' && window.M.navigator.device('ios') ? (
                    <a
                      href="#"
                      onClick={() => fileDownload(process.env.REACT_APP_API_URL + '/portal/file/' + item?.encryptedId, item.originFileNm)}
                      title="첨부파일"
                      download
                    >
                      (첨부{idx + 1}) {item.originFileNm}
                    </a>
                  ) : (
                    <a href={process.env.REACT_APP_API_URL + '/portal/file/' + item?.encryptedId} title="첨부파일" download>
                      (첨부{idx + 1}) {item.originFileNm}
                    </a>
                  )}
                  <br />
                </React.Fragment>
              )
            })}
          </ul>
        </li>
        <li className="view-cont">
          {props.select?.question?.split('\n').map((line, idx) => {
            return (
              <span key={'q' + idx}>
                {line}
                <br />
              </span>
            )
          })}
        </li>
      </ul>
      {props.select?.ansYn === 'Y' ? (
        <ul className="view-board reply">
          <li className="view-info">
            <div className="left">
              <span className="tit">답변자</span>
              <em>{props.select?.ansRegMemberId}</em>
            </div>
            <div className="right">
              <span className="tit">답변일시</span>
              <em>{moment(props.select?.ansRegDt).format('YYYY.MM.DD h:mm')}</em>
            </div>
          </li>
          <li className="view-attach">
            <div className="tit">첨부파일</div>
            <ul className="attach-list">
              {props.select?.ansPtlFileDtoList?.map((item, idx) => {
                return (
                  <React.Fragment key={idx}>
                    <a href={process.env.REACT_APP_API_URL + '/portal/file/' + item?.encryptedId} title="첨부파일" download>
                      (첨부{idx + 1}) {item.originFileNm}
                    </a>
                    <br />
                  </React.Fragment>
                )
              })}
            </ul>
          </li>
          <li className="view-cont">
            {props.select?.ans?.split('\n').map((line, idx) => {
              return (
                <span key={'a' + idx}>
                  {line}
                  <br />
                </span>
              )
            })}
          </li>
        </ul>
      ) : (
        <ul className="view-board reply">
          <li className="no-data">답변 내용이 없습니다.</li>
        </ul>
      )}
      <div className="btn-block">
        <span className="right">
          <button href="#" className="btn-primary md" onClick={goList}>
            목록
          </button>
          {props.select?.mineYn === 'Y' && state?.ansYn === 'N' && (
            <span>
              {props.select.encPasswd === '' ? (
                <React.Fragment>
                  <button
                    className="btn-primary md"
                    style={{ backgroundColor: '#419641', marginLeft: '10px' }}
                    onClick={() => history.push({ pathname: '/questionwrite', state: { seq: props.select?.questSeq } })}
                  >
                    수정
                  </button>
                  <button
                    className="btn-primary md"
                    style={{ backgroundColor: '#c12e2a', marginLeft: '10px' }}
                    onClick={() => props.showPwdPopup(true, 'PDELETE', props.select?.questSeq, false)}
                  >
                    삭제
                  </button>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <button
                    className="btn-primary md"
                    style={{ backgroundColor: '#419641', marginLeft: '10px' }}
                    onClick={() => props.showPwdPopup(true, 'EDIT', props.select?.questSeq, false)}
                  >
                    수정
                  </button>
                  <button
                    className="btn-primary md"
                    style={{ backgroundColor: '#c12e2a', marginLeft: '10px' }}
                    onClick={() => props.showPwdPopup(true, 'DELETE', props.select?.questSeq, false)}
                  >
                    삭제
                  </button>
                </React.Fragment>
              )}
            </span>
          )}
        </span>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  return {
    fileList: state.quest.select?.ptlFileDtoList,
    select: state.quest.select,
    //자신이 등록하지 않은 문의 사항 컨텐츠 내용과 파일정보가 보여서 삭제함.
    // prev : state.quest.prev,
    // next : state.quest.next,
    token: state.quest.token,
    isShowPwdPopup: state.quest.showPwdPopup,
  }
}
const actionCreators = {
  detail: questionActions.detail,
  showPwdPopup: questionActions.showPwdPopup,
  del: questionActions.del,
}

export default connect(mapStateToProps, actionCreators)(QuestionDetail)
